import React, { useEffect } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { PatternSection } from '../components/landing/PatternSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { BenefitsSectionWithCheckout } from '../components/landing/BenefitsSectionWithCheckout';
import { FAQSection } from '../components/landing/FAQSection';
import { CTASectionWithCheckout } from '../components/landing/CTASectionWithCheckout';
import { PurchaseNotifier } from '../components/PurchaseNotifier';
import { ConsequencesSection, ProtocolIntroSection, ProgramIncludesSection, AuthorSection, WrittenTestimonialsSection } from '../components/landing/FunnelSections';
export function LandingPageCanino1() {
  useEffect(() => {
    document.title = '30 Recetas Naturales para Perros';
  }, []);
  const checkoutUrl = 'https://pay.hotmart.com/Y104256235W?off=mstmo7g1&checkoutMode=10&bid=1773273486617';
  return <main className="min-h-screen bg-gradient-to-b from-orange-50/20 to-yellow-50/20 font-sans text-gray-900" data-id="element-1391">
      <HeroSection data-id="element-1392" />
      <PatternSection hideAudio data-id="element-1393" />
      <ConsequencesSection data-id="element-1394" />
      <ProtocolIntroSection data-id="element-1395" />
      <ProgramIncludesSection data-id="element-1396" />
      <AuthorSection data-id="element-1397" />
      <WrittenTestimonialsSection data-id="element-1398" />
      <BenefitsSectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1399" />
      <ProblemSection data-id="element-1400" />
      <SolutionSection data-id="element-1401" />
      <FAQSection data-id="element-1402" />
      <CTASectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1403" />
      <footer className="bg-orange-50/30 py-12 border-t border-orange-100" data-id="element-1404">
        <div className="container mx-auto px-4 text-center" data-id="element-1405">
          <p className="text-gray-500 text-sm" data-id="element-1406">
            © {new Date().getFullYear()} Recetas Anti-Inflamación para Perros.
            Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-xs mt-2" data-id="element-1407">
            Este producto es una guía educativa y no sustituye el consejo
            veterinario profesional.
          </p>
        </div>
      </footer>
      <PurchaseNotifier enabled={true} displayPrice="$69.999 COP" data-id="element-1408" />
    </main>;
}